import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {debounceTime, Observable} from "rxjs";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators} from "@angular/forms";
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from "@angular/router";
import {CoreService} from "../../../services/core.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {AutoComplete} from "../../auto-complete";
import {HandleListName} from "../../functions/shared-functions";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {filter, map, startWith} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
import {phone_pattern} from "../../variables/variables";
import {DoorsResolver} from "../../../resolvers/doors.resolver";
import {GlobalService} from "../../../services/global.service";

@UntilDestroy()
@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent extends AutoComplete implements OnInit, OnChanges {
  countriesFilteredOptions: Observable<any[]>;
  active_statusFilteredOptions: Observable<any[]>;
  support_typesFilteredOptions: Observable<any[]>;
  problems_typesFilteredOptions: Observable<any[]>;
  statusFilteredOptions: Observable<any[]>;
  gendersFilteredOptions: Observable<any[]>;
  supportTicketsStatusFilteredOptions: Observable<any[]>;
  supportTicketsStatus = [
    {
      name: 'Opened',
      id: 1,
      color: '#026c17'
    },
    {
      name: 'Pending',
      id: 2,
      color: '#efc48f',
    },
    {
      name: 'Closed',
      id: 3,
      color: '#b90707'
    },
  ];
  statues = [
    {
      name: this.translateService.instant('Read'),
      id: 1
    },
    {
      name: this.translateService.instant('Not Read'),
      id: 2
    },
  ];
  activeStatues = [
    {
      name: this.translateService.instant('ACTIVE'),
      id: '1'
    },
    {
      name: this.translateService.instant('NOT ACTIVE'),
      id: '2'
    },
  ];

  support_types = [];
  problems_types = [];
  countries: any[] = [];
  donationPaths: any[] = [
    {
      name: this.translateService.instant('All donations'),
      id: -1
    },
    {
      name: this.translateService.instant('Short Courses'),
      id: 1
    },
    {
      name: this.translateService.instant('Accreditation and Assignment'),
      id: 2
    },
    {
      name: this.translateService.instant('Diplomas'),
      id: 3
    },
    {
      name: this.translateService.instant('Free Reading'),
      id: 4
    },
  ];
  genders: any[] = [
    {
      name: this.translateService.instant('Male'),
      id: 1
    },
    {
      name: this.translateService.instant('Female'),
      id: 2
    },
  ];
  form: UntypedFormGroup;
  currency = environment.currency;
  apiUrl = environment.webUrl;
  @Output() filter = new EventEmitter<any>();
  @Input() listType: any;
  @Input() reset: any = true;
  dropdownSettings = {};
  placeholderText: string = this.translateService.instant('Select');
  selectAllText: string = this.translateService.instant('Select all');
  unSelectAllText: string = this.translateService.instant('Unselect all');
  searchText: string = this.translateService.instant('type name...');
  disabled = false;
  noDataAvailText: string = this.translateService.instant('No data available');
  doors = [];
  in_performance = false;

  constructor(private route: ActivatedRoute,
              private coreService: CoreService,
              private cd: ChangeDetectorRef,
              private toastr: ToastrService,
              private doorsResolver: DoorsResolver,
              private router: Router,
              private globalService: GlobalService,
              public translateService: TranslateService,
              private activatedRoute: ActivatedRoute,
              private fb: UntypedFormBuilder) {
    super()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.reset && this.form) {
      // this.resetForm();
    }
  }

  ngOnInit(): void {
    this.in_performance = window?.location?.href?.includes('performance');
    this.setNewAutoSetting();
    this.form = this.fb.group({
      country: new UntypedFormControl('', []),
      gender: new UntypedFormControl(null, []),
      from_date: new UntypedFormControl(null, []),
      to_date: new UntypedFormControl(null, []),
      support_type: new UntypedFormControl(null, []),
      notifications_status: new UntypedFormControl(null, []),
      problems_type: new UntypedFormControl(null, []),
      door_id: new UntypedFormControl(null, []),
      form_reset: new UntypedFormControl(false, []),
      ticket_status: new UntypedFormControl(false, []),
      active_status: new UntypedFormControl(null, []),
    }, {validators: [this.checkAutoComplete()]})
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      untilDestroyed(this)
    ).subscribe((res: any) => {
      this.globalService.filterChangedSubject.next(undefined);
      this.form.reset();
      this.in_performance = res?.url?.includes('performance');
      if ((this.listType === 'users' && this.in_performance && !this.doors?.length)) {
        this.getDoors();
      }
    });
    this.handlerAutocomplete('gender');
    this.handlerAutocomplete('notifications_status');
    if (this.listType === 'challenges' || (this.listType === 'users' && this.in_performance)) {
      this.getDoors();
    }
    if (this.listType === 'support_tickets') {
      this.getSupportTypes();
      this.getProblemsTypes();
      this.handlerAutocomplete('ticket_status');
    }
    // this.resetForm();
    this.form.valueChanges.pipe(debounceTime(3000)).subscribe((res) => {
      // if (this.form.status === 'VALID') {
      //   this.filter.emit(res);
      // }
    })
  }

  getDoors() {
    this.doorsResolver.resolve().pipe(untilDestroyed(this)).subscribe(res => {
      this.doors = res?.data;
    });
  }

  resetForm() {
    this.form.reset();
    this.form.controls['form_reset'].setValue(true);
    this.filter.emit(this.form.value);
  }

  setNewAutoSetting() {
    this.dropdownSettings = {
      'singleSelection': false,
      'defaultOpen': false,
      'idField': 'id',
      'textField': 'name',
      'selectAllText': this.selectAllText,
      'unSelectAllText': this.unSelectAllText,
      'searchPlaceholderText': this.searchText,
      'noDataAvailablePlaceholderText': this.noDataAvailText,
      'enableCheckAll': true,
      'itemsShowLimit': 'All',
      'allowSearchFilter': true
    };
  }


  getCountries() {
    this.coreService.getRequest('countries/all').pipe(untilDestroyed(this)).subscribe(res => {
      this.countries = HandleListName(res.data);
      this.handlerAutocomplete('country');
    })
  }

  getSupportTypes() {
    this.coreService.getRequest('admin/support_types').pipe(untilDestroyed(this)).subscribe(res => {
      this.support_types = HandleListName(res.support_types);
      this.handlerAutocomplete('support_types');
    })
  }

  getProblemsTypes() {
    this.coreService.getRequest('admin/problems_types').pipe(untilDestroyed(this)).subscribe(res => {
      this.problems_types = HandleListName(res.problems_types);
      this.handlerAutocomplete('problems_types');
    })
  }

  handlerAutocomplete(type) {
    if (type === 'country') {
      this.countriesFilteredOptions = this.fillAutocomplete(this.form, 'country', this.countries);
    } else if (type === 'gender') {
      this.gendersFilteredOptions = this.fillAutocomplete(this.form, 'gender', this.genders);
    } else if (type === 'support_types') {
      this.support_typesFilteredOptions = this.fillAutocomplete(this.form, 'support_type', this.support_types);
    } else if (type === 'problems_types') {
      this.problems_typesFilteredOptions = this.fillAutocomplete(this.form, 'problems_type', this.problems_types);
    } else if (type === 'notifications_status') {
      this.statusFilteredOptions = this.fillAutocomplete(this.form, 'notifications_status', this.statues);
    } else if (type === 'ticket_status') {
      this.supportTicketsStatusFilteredOptions = this.fillAutocomplete(this.form, 'ticket_status', this.supportTicketsStatus);
    } else if (type === 'active_status') {
      this.active_statusFilteredOptions = this.fillAutocomplete(this.form, 'active_status', this.activeStatues);
    }
  }

  checkAutoComplete() {
    return (formGroup: UntypedFormGroup) => {
      const country = formGroup?.controls['country'];
      const gender = formGroup?.controls['gender'];
      const support_type = formGroup?.controls['support_type'];
      const problems_type = formGroup?.controls['problems_type'];
      const notifications_status = formGroup?.controls['notifications_status'];
      const ticket_status = formGroup?.controls['ticket_status'];
      const active_status = formGroup?.controls['active_status'];
      //////////////////////////////////////////////////////////////
      const indexCountry = this.countries.findIndex(res => res?.id === country.value?.id);
      const indexGender = this.genders.findIndex(res => res?.id === gender.value?.id);
      const indexSupportTypes = this.listType === 'support_tickets' ? this.support_types.findIndex(res => res?.id === support_type.value?.id) : 0;
      const indexProblemsTypes = this.listType === 'support_tickets' ? this.problems_types.findIndex(res => res?.id === problems_type.value?.id) : 0;
      const indexNotifications_status = this.listType === 'notifications' ? this.statues.findIndex(res => res?.id === notifications_status.value?.id) : 0;
      const indexTicket_status = this.listType === 'support_tickets' ? this.supportTicketsStatus.findIndex(res => res?.id === ticket_status.value?.id) : 0;
      const indexActive_status = (this.listType === 'students' || this.listType === 'teachers') ? this.activeStatues.findIndex(res => res?.id === active_status.value?.id) : 0;
      this.checkWrongError(indexCountry, country);
      this.checkWrongError(indexGender, gender);
      this.checkWrongError(indexSupportTypes, support_type);
      this.checkWrongError(indexProblemsTypes, problems_type);
      this.checkWrongError(indexNotifications_status, notifications_status);
      this.checkWrongError(indexTicket_status, ticket_status);
      this.checkWrongError(indexActive_status, active_status);
    }
  }


  apply() {
    if (this.form.status === 'VALID') {
      this.filter.emit(this.form.value);
    }
  }
}
